const manage_incident_method_helpers = {
    file_to_url(file) {
        if (!file) {
            return null;
        }
        if (typeof file === "string") {
            return file;
        }
        if (file instanceof File || file instanceof Blob) {
            return URL.createObjectURL(file);
        }
        return null;
    },
}

export default manage_incident_method_helpers;
